export const Footer = () => (
  <p id="footerText">
    <strong>
      <em>Copy Pics</em>
    </strong>{" "}
    is a new toy by <a href="https://photobot.Co">Photobot.Co</a> -{" "}
    <a href="mailto:info@photobot.co">Say hi</a>
  </p>
);
